import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=2a4b583d&scoped=true&"
import script from "./PageNotFound.vue?vue&type=script&lang=ts&"
export * from "./PageNotFound.vue?vue&type=script&lang=ts&"
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=2a4b583d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b583d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
